import { defineMessages } from 'react-intl';

export default defineMessages({
  inPersonVisitDetails: {
    id: 'repvisits.calendar.availability.inPersonVisitDetails',
    defaultMessage: 'In-person Visit Details',
  },
  virtualVisitDetails: {
    id: 'repvisits.calendar.availability.virtualVisitDetails',
    defaultMessage: 'Virtual Visit Details',
  },
  visitDetails: {
    id: 'repvisits.calendar.availability.visitDetails',
    defaultMessage: 'Visit Details',
  },
  fairDetails: {
    id: 'repvisits.calendar.availability.fairDetails',
    defaultMessage: 'College Fair Details',
  },
  contact: {
    id: 'common.contact',
    defaultMessage: 'Contact',
  },
  date: {
    id: 'common.date',
    defaultMessage: 'Date',
  },
  time: {
    id: 'common.time',
    defaultMessage: 'Time',
  },
  school: {
    id: 'common.school',
    defaultMessage: 'High School',
  },
  reschedule: {
    id: 'common.reschedule',
    defaultMessage: 'Rescheduling',
  },
  rescheduleDeadlinePassed: {
    id: 'repvisits.event.details.reschduleDeadlinePassed',
    defaultMessage: 'This high school requires that you call or email to reschedule your appointment.',
  },
  save: {
    id: 'common.save',
    defaultMessage: 'Save',
  },
  virtualVisitHint: {
    id: 'repvisits.event.details.virtualVisitHint',
    defaultMessage: 'Virtual Visit URL:',
  },
  confirm: {
    id: 'common.confirm',
    defaultMessage: 'Confirm',
  },
  close: {
    id: 'common.close',
    defaultMessage: 'Close',
  },
  addVisitUrlTitle: {
    id: 'repvisits.event.details.changeVisitUrlTitle',
    defaultMessage: 'Add Virtual Visit Url',
  },
  addVisitUrlError: {
    id: 'repvisits.event.details.addVisitUrlError',
    defaultMessage: 'Something went wrong while saving the visit url, please try again later.',
  },
  visitUrlAddedPart1: {
    id: 'repvisits.event.details.visitUrlAddedPart1',
    defaultMessage: 'Virtual Visit with ',
  },
  visitUrlAddedPart2: {
    id: 'repvisits.event.details.visitUrlAddedPart2',
    defaultMessage: ' confirmed.',
  },
  notes: {
    id: 'repvisits.calendar.availability.notes',
    defaultMessage: 'Notes',
  },
  internalNotes: {
    id: 'repvisits.calendar.availability.internalNotes',
    defaultMessage: 'Internal Notes',
  },
  instructions: {
    id: 'repvisits.calendar.availability.instructions',
    defaultMessage: 'Instructions from High School',
  },
  cost: {
    id: 'repvisits.calendar.availability.cost',
    defaultMessage: 'Cost',
  },
  expectedstudents: {
    id: 'repvisits.calendar.availability.expectedstudents',
    defaultMessage: 'Number of Expected Students',
  },
  cancellationDetails: {
    id: 'repvisits.event.details.cancellationDetails',
    defaultMessage: 'This school allows you to cancel visits up to {numDays} days before the event.',
  },
  cancellationDetailsFair: {
    id: 'repvisits.event.details.cancellationDetailsFair',
    defaultMessage: 'This school allows you to cancel your fair registration until {date}.',
  },
  cancellationLink: {
    id: 'repvisits.event.details.cancellationLink',
    defaultMessage: 'Cancel This Visit',
  },
  cancellationLinkFair: {
    id: 'repvisits.event.details.cancellationLinkFair',
    defaultMessage: 'Cancel This Fair',
  },
  cancelDeadlinePassed: {
    id: 'repvisits.event.details.cancelDeadlinePassed',
    defaultMessage: 'This high school requires that you call or email to cancel your appointment.',
  },
  cancellation: {
    id: 'repvisits.event.details.cancellation',
    defaultMessage: 'Cancellation',
  },
  rescheduleTitle: {
    id: 'repvisits.event.visit.rescheduleTitle',
    defaultMessage: 'Reschedule Availability',
  },
  reschedulePolicy: {
    id: 'repvisits.event.visit.reschedulePolicy',
    defaultMessage: 'This school allows you to reschedule visits up to {days} days before the event. ',
  },
  rescheduleLink: {
    id: 'repvisits.event.visit.reschedule',
    defaultMessage: 'Reschedule this visit',
  },
  rescheduleAndCancel: {
    id: 'repvisits.event.visit.rescheduleAndCancel',
    defaultMessage: 'Rescheduling and Cancellation Policies',
  },
  cancellationSuccess: {
    id: 'repvisits.event.visit.cancellation.success',
    defaultMessage: 'Your visit has been cancelled and the high school has been notified',
  },
  cancellationFail: {
    id: 'repvisits.event.visit.cancellation.failure',
    defaultMessage: 'Unable to cancel visit',
  },
  cancellationSuccessFair: {
    id: 'repvisits.event.visit.cancellation.successFair',
    defaultMessage: 'Your fair has been cancelled and the high school has been notified',
  },
  cancellationFailFair: {
    id: 'repvisits.event.visit.cancellation.failureFair',
    defaultMessage: 'Unable to cancel fair',
  },
  cancellationHeader: {
    id: 'repvisits.event.visit.cancellation.header',
    defaultMessage: 'Are you sure you want to cancel?',
  },
  cancellationPrompt: {
    id: 'repvisits.event.visit.cancellation.prompt',
    defaultMessage: 'Include a message that will be sent to the high school regarding the cancellation',
  },
  confirmCancellation: {
    id: 'repvisits.event.visit.cancellation.confirm',
    defaultMessage: 'Yes, Cancel Visit',
  },
  confirmCancellationFair: {
    id: 'repvisits.event.visit.cancellation.confirmFair',
    defaultMessage: 'Yes, Cancel Fair',
  },
  cancellationGoBack: {
    id: 'repvisits.event.visit.cancellation.goBack',
    defaultMessage: 'No, Go Back',
  },
  saveSuccessTitle: {
    id: 'repvisits.event.details.saveSuccessTitle',
    defaultMessage: 'Great!',
  },
  saveSuccessDescription: {
    id: 'repvisits.event.details.saveSuccessDescription',
    defaultMessage: 'Your visit has been updated',
  },
  saveFail: {
    id: 'repvisits.event.details.saveFail',
    defaultMessage: 'Unable to save notes',
  },
  notesPlaceholder: {
    id: 'repvisits.event.details.notesPlaceholder',
    defaultMessage: 'Upgrade your account to add custom notes to this visit.',
  },
  title: {
    id: 'community.availabilitySidebar.title',
    defaultMessage: 'Repvisits Availability',
  },
  prevWeek: {
    id: 'repvisits.search.prevWeek',
    defaultMessage: 'Previous week',
  },
  nextWeek: {
    id: 'repvisits.search.nextWeek',
    defaultMessage: 'Next week',
  },
  showingWeek: {
    id: 'repvisits.event.visit.showingWeek',
    defaultMessage: 'Showing week: ',
  },
  selectWeek: {
    id: 'community.availabilitySidebar.goToDate',
    defaultMessage: 'Go to date',
  },
  successDescription: {
    id: 'repvisits.travel.plan.successDescription',
    defaultMessage: 'School added to Travel Plan',
  },
  failureDescription: {
    id: 'repvisits.travel.plan.failureDescription',
    defaultMessage: 'Something unexpected happened. Please try your request again.',
  },
  interestedStudents: {
    id: 'repvisits.calendar.availability.interestedStudents',
    defaultMessage: 'Interested Students',
  },
});
